import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CapabilityService } from "../../../../auth/service/capability.service";
import { RoleService } from "../../../../auth/service/role.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { ICapability, ICapabilityAssignRemove } from "app/auth/models/capabilities";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IRole } from "app/auth/models/role";

@Component({
  selector: "app-capability-assign",
  templateUrl: "./capability-assign.component.html",
  styleUrls: ["./capability-assign.component.scss"],
})
export class CapabilityAssignComponent implements OnInit {
  public capabilities: ICapability[];
  public roles: IRole[];
  public rolesToShow: IRole[];
  public cap_for_role: ICapabilityAssignRemove | {} = {};
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public filter_role: number = -1;
  public showRole: number = 0;
  public roleColumnWidth: { string: number } | {} = {};
  public filteredCapabilities: ICapability[];

  constructor(
    private _capabilityService: CapabilityService,
    private _roleService: RoleService,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public _changeDetectorRef: ChangeDetectorRef,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.CAPABILITY_USER",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.CAPABILITY_USER",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    await this.loadData();
    this.handlerClickRole();
  }

  async loadData() {
    await this._capabilityService.getList().then((list: Array<object>) => {
      this.capabilities = list.map((cap: ICapability) => {
        cap.role_ids_old = cap.role_ids.map((i) => i);
        return cap;
      });
    });

    if (this._roleService.list.length < 1) {
      await this._roleService.getList();
    }

    const rolesNotAvailables: string[] = ["Candidato", "Dipendente", "Collaboratore"];

    this.roles = this._roleService.list
      .filter((role: IRole) => !rolesNotAvailables.includes(role.name))
      .sort((a: IRole, b: IRole) => {
        return a.order > b.order ? 1 : a.order < b.order ? -1 : 0;
      })
      .map((role: IRole) => {
        this.cap_for_role[role.id] = {
          assign: [],
          remove: [],
        };
        return role;
      });
    this.loadRow();
    this.filterCapabilities();
  }

  loadRow() {
    if (this.showRole != 0) {
      this.rolesToShow = this.roles.filter((item: IRole) => Number(item.id) === Number(this.showRole));
    } else {
      this.rolesToShow = this.roles;
    }
    this.rolesToShow.map((role) => {
      this.roleColumnWidth[role.name] = role.name.length * 12;
      this.roleColumnWidth[role.name] = this.roleColumnWidth[role.name] < 50 ? 50 : this.roleColumnWidth[role.name];
    });
  }

  resetFilterRole() {
    this.showRole = 0;
    this.loadRow();
    this.handlerClickRole();
  }

  handlerClickRole() {
    setTimeout(() => {
      const roleLabel: any = document.querySelectorAll(".role-label");
      roleLabel.forEach((item) => {
        item.addEventListener("click", (event) => {
          try {
            const roleName: string = event.target.innerText.toLowerCase();
            const role: IRole = this.roles.find((r: IRole) => r.name.toLowerCase() === roleName);
            this.showRole = Number(role.id);
            this.loadRow();
          } catch (e) {
            console.error(e.message);
          }
        });
      });
    });
  }

  handlerClickCapability(capability_id: number, role_id: number) {
    const capability: ICapability = this.capabilities.find((cap: ICapability) => cap.id === capability_id);
    let newRoles: number[] = capability.role_ids;

    const myCheck = capability.role_ids.includes(role_id);

    if (myCheck) {
      newRoles = newRoles.filter((r: number) => r !== role_id);
      this.cap_for_role[role_id].assign = this.cap_for_role[role_id].assign.filter((r: number) => r !== capability_id);
      if (capability.role_ids_old.includes(role_id)) {
        this.cap_for_role[role_id].remove.push(capability_id);
      }
    } else {
      newRoles.push(role_id);
      if (!capability.role_ids_old.includes(role_id)) {
        this.cap_for_role[role_id].assign.push(capability_id);
      }
      this.cap_for_role[role_id].remove = this.cap_for_role[role_id].remove.filter((r: number) => r !== capability_id);
    }

    this.capabilities = this.capabilities.map((cap: ICapability) => {
      if (cap.id === capability_id) {
        cap.role_ids = newRoles;
      }
      return cap;
    });

    this.rolesToShow = null;
    this.filteredCapabilities = null;
    this.filterCapabilities();
  }

  filterCapabilities() {
    let caps: ICapability[] = this.capabilities.filter((i: ICapability) => i);

    if (this.searchKeyword.length > 0) {
      const keyword: string = this.searchKeyword.toLowerCase().trim();
      caps = caps.filter((c: ICapability) => c.name.toLowerCase().includes(keyword) || c.code.toLowerCase().includes(keyword));
    }

    if (this.filter_role >= 0) {
      caps = caps.filter((item: ICapability) => item.role_ids.includes(this.filter_role));
    } else if (this.filter_role === -2) {
      caps = caps.filter((item: ICapability) => item.role_ids.length === 0);
    }
    this.filteredCapabilities = caps;
    this.loadRow();
  }

  buttonIsDisabled() {
    let count: number = 0;

    Object.keys(this.cap_for_role).map((key) => {
      if (this.cap_for_role[key]) {
        count += this.cap_for_role[key].assign.length || 0;
        count += this.cap_for_role[key].remove.length || 0;
      }
    });

    return count < 1;
  }

  async save() {
    if (!this._authenticationService.hasCapability("assign_capability")) {
      window.history.back();
      return false;
    }

    this._utilService.showLoading();

    Object.keys(this.cap_for_role).map((roleId) => {
      const cfr = this.cap_for_role[roleId];
      if (cfr.assign.length < 1 && cfr.remove.length < 1) {
        delete this.cap_for_role[roleId];
      }
    });
    await this._capabilityService
      .batch_assign_unassign(this.cap_for_role)
      .then(async () => {
        this.loadRow();
        this.filterCapabilities();
        this.resetFilterRole();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CAPABILITY_ASSIGN" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_CAPABILITY_ASSIGN" });
      });
  }
}
